<!-- 手机二级菜单 -->
<template>
  <div class="next-menu">
    <el-button type="text" :disabled="activeNum==-1" @click="change(0,dataSource[activeNum])">
      <i class="el-icon-arrow-left" v-if="activeNum>=0"></i>
      <span>{{dataSource[activeNum]}}</span>
    </el-button>
    <el-button
      type="text"
      @click="change(1,dataSource[activeNum+2])"
      :disabled="activeNum+2==dataSource.length"
    >
      <span>{{dataSource[activeNum+2]}}</span>
      <i class="el-icon-arrow-right" v-if="activeNum+2!=dataSource.length"></i>
    </el-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { backTop } from '@/utils/util'
export default {
  name: '',
  computed: {
    ...mapGetters(['pageData']),
    dataSource() {
      if (this.$route.meta.main) {
        return Object.keys(this.pageData['mainMenu'][this.$route.meta.main]['menu'][
          this.$route.query.menu
        ]['first'][
          this.$route.query.first
        ]['second'])
      } else {
        return []
      }
    }
  },
  mounted() {
    const menu = Object.keys(this.pageData['mainMenu'][this.$route.meta.main]['menu'][
      this.$route.query.menu
    ]['first'][
      this.$route.query.first
    ]['second'])
    this.activeNum = menu.indexOf(this.$route.query.second) - 1
  },
  watch: {
    $route(to, from) {
      if (to.query.menu != from.query.menu || to.query.second == '概述') {
        this.activeNum = -1
      }
    }
  },
  data() {
    return {
      activeNum: -1
    }
  },
  methods: {
    change(key, val) {
      key ? this.activeNum++ : this.activeNum--
      backTop(this)
      this.$router.push({
        name: this.$route.meta.collapse,
        query: {
          menu: this.$route.query.menu,
          first: this.$route.query.first,
          second: val,
          dir: true
        }
      })
    }
  }

}
</script>
<style lang='less' scoped>
.next-menu {
  width: 100%;
  display: flex;
  justify-content: space-between;
  > .el-button {
    color: #000;
    /deep/span {
      /deep/ span {
        font-family: 'SourceHanSansCN-Regular' !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gPhoneCollapse.vue